// ChairLounge behaviour shared by every page: adding to the cart and scroll reveal.
// Section-specific behaviour lives in assets/cl-header.js, cl-configurator.js and cl-sticky-order.js.
// window.ChairLounge is created in snippets/cl-head.liquid with the cart routes.
(() => {
  const ChairLounge = (window.ChairLounge = window.ChairLounge || {});
  const routes = ChairLounge.routes || {};
  ChairLounge.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- cart ---------- */
  // Adds items to the cart. `extra` can request re-rendered sections (used by the cart drawer).
  ChairLounge.addToCart = async (items, extra = {}) => {
    const res = await fetch(`${routes.cartAdd || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, ...extra }),
    });
    const json = await res.json().catch(() => ({}));
    // Shopify's own message is already in the shopper's language; callers fall back to theirs.
    if (!res.ok || json.status) throw new Error(json.description || json.message || '');
    return json;
  };

  /* ---------- reveal on scroll ---------- */
  const revealAll = (root = document) => root.querySelectorAll('.cl-reveal').forEach((el) => el.classList.add('is-in'));
  if (ChairLounge.reduceMotion || !('IntersectionObserver' in window)) {
    revealAll();
    document.addEventListener('shopify:section:load', (e) => revealAll(e.target));
  } else {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
    );
    const observe = (root = document) => root.querySelectorAll('.cl-reveal:not(.is-in)').forEach((el) => io.observe(el));
    observe();
    document.addEventListener('shopify:section:load', (e) => observe(e.target));
  }
})();
